module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advisor_tiktok_desktop_03@2x-1b8503164f61f633301689b04b897925.jpg";